// extracted by mini-css-extract-plugin
export var readonly = "_gu-1";
export var star = "_gu-0";